import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/MandatoryDisclosure/MandatoryDisclosure.tsx");
